/* eslint-disable import/prefer-default-export */
import { aquaAxiosWithCreds, callAsyncWithRetry, devLog } from 'lib/utilityFunctions';
import { FLUENCY_STUDENT_ASSIGNMENTS_URL } from './endpoints';

/**
 * Fetches all fluency assignments for the authenticated student.
 * @returns {Promise<Array>} Array of StudentAssignment objects, each with
 *   assignmentId, status, micCheckFailure, startDate, dueDate, passage, and attempts.
 */
export const fetchStudentAssignments = async () => {
  const asyncRetryFn = async () => {
    const { data } = await aquaAxiosWithCreds(FLUENCY_STUDENT_ASSIGNMENTS_URL);
    return data;
  };

  const asyncRetryConfig = {
    logger: (error, { isDoneRetrying }) => {
      if (isDoneRetrying) {
        devLog('[fetchStudentAssignments] Failed after 3 retries');
      }
    },
  };

  return callAsyncWithRetry(asyncRetryFn, asyncRetryConfig);
};
